import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaterSki = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 69,
	height: 91,
	viewBox: "0 0 69 91",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40.244 6.8073C41.717 4.8753 44.417 2.5593 46.244 1.6593C48.07 0.759299 50.8839 0.0122984 52.4979 0.000298356C57.3399 -0.0377016 63.461 3.5593 65.88 7.8633C68.023 11.6773 68.064 12.4893 68.064 51.3633V90.9773H52.531H36.999L37.281 50.6483L37.564 10.3193L40.244 6.8073ZM56.516 7.3923C58.379 8.1713 60.389 9.7163 60.984 10.8273C61.636 12.0473 62.064 19.5993 62.064 29.9113V46.9773H52.5H42.9349L43.25 29.5793C43.534 13.8423 43.755 11.9693 45.564 9.9613C47.393 7.9303 50.3879 6.1993 52.3459 6.0403C52.7759 6.0063 54.653 6.6143 56.516 7.3923ZM53.119 62.9773C50.315 62.9773 50.159 62.7493 49.869 58.2273C49.59 53.8753 49.333 53.4503 46.808 53.1603C45.16 52.9703 43.8419 53.3913 43.5299 54.2063C43.2419 54.9563 43.1319 62.0733 43.2849 70.0233L43.564 84.4773L52.814 84.7653L62.064 85.0523V69.0153V52.9773H59.064C56.131 52.9773 56.064 53.0883 56.064 57.9773C56.064 62.8453 55.986 62.9773 53.119 62.9773Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.315977 45.1805C0.518775 14.6285 0.563313 7.91875 3.93661 4.7262C4.88593 3.82774 6.09889 3.20784 7.6532 2.41348C7.94462 2.26455 8.24803 2.10948 8.56396 1.9453C13.73 -0.739702 19.804 -0.221701 24.417 3.2973C31.052 8.3583 31.064 8.4483 31.064 51.8783V90.9773H15.532H0L0.281982 50.2273C0.294099 48.4764 0.305259 46.7952 0.315977 45.1805ZM22.064 9.5593C24.512 11.9683 24.571 12.3803 24.897 29.4983L25.229 46.9773H15.647H6.06396V29.9113C6.06396 19.6163 6.49194 12.0463 7.14294 10.8303C8.56194 8.1783 13.92 5.8693 17.064 6.5553C18.439 6.8543 20.689 8.2063 22.064 9.5593ZM15.0089 62.9773C12.1419 62.9773 12.064 62.8453 12.064 57.9773C12.064 53.0883 11.997 52.9773 9.06396 52.9773H6.06396V69.0153V85.0523L15.314 84.7653L24.564 84.4773V68.9773V53.4773H21.564C18.694 53.4773 18.5509 53.6843 18.2589 58.2273C17.9689 62.7493 17.8129 62.9773 15.0089 62.9773Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgWaterSki);
export { ForwardRef as ReactComponent };
